import { render, staticRenderFns } from "./NsProductDetailCarousel.vue?vue&type=template&id=0ed0768a&scoped=true&"
import script from "./NsProductDetailCarousel.vue?vue&type=script&lang=js&"
export * from "./NsProductDetailCarousel.vue?vue&type=script&lang=js&"
import style0 from "./NsProductDetailCarousel.vue?vue&type=style&index=0&id=0ed0768a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../packages/aem/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ed0768a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jenkins/workspace/webcomponents-ui - release-finish/src/main/content/webcomponents/js/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0ed0768a')) {
      api.createRecord('0ed0768a', component.options)
    } else {
      api.reload('0ed0768a', component.options)
    }
    module.hot.accept("./NsProductDetailCarousel.vue?vue&type=template&id=0ed0768a&scoped=true&", function () {
      api.rerender('0ed0768a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "node_modules/@nuskin/product-components/components/NsProductDetailCarousel.vue"
export default component.exports